module.exports = require('./helpers/bundle-url').getBundleURL('6VRlG') + "logo.7718c6df.svg";